import { render, staticRenderFns } from "./PermissionsView.vue?vue&type=template&id=9b55aa5e&"
import script from "./PermissionsView.vue?vue&type=script&lang=js&"
export * from "./PermissionsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports